module.exports = __webpack_public_path__ + "img/sadness.ad0a2974.svg";